export default __webpack_public_path__ + "static/media/raspberry-pi-1.aef5a394.jpg";